function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { shape, string, node, bool, oneOf } from 'prop-types';
import VisuallyHiddenText from '@bbc/psammead-visually-hidden-text';
import { C_WHITE, C_POSTBOX, C_EBON, C_GHOST } from '@bbc/psammead-styles/colours';
import { GEL_SPACING_HLF, GEL_SPACING, GEL_SPACING_SEXT } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_2_SCREEN_WIDTH_MAX, GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_5_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
import { getPica } from '@bbc/gel-foundations/typography';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
import { NAV_BAR_TOP_BOTTOM_SPACING } from './DropdownNavigation';
var SPACING_AROUND_NAV_ITEMS = "".concat(NAV_BAR_TOP_BOTTOM_SPACING, "rem"); // 12px

var CURRENT_ITEM_HOVER_BORDER = '0.3125rem'; // 5px

/* White with 30% transparency over #B80000 */

var BORDER_COLOR = '#eab3b3';
var NavWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "NavWrapper",
  componentId: "sc-158x7z5-0"
})(["position:relative;max-width:", ";margin:0 auto;"], GEL_GROUP_5_SCREEN_WIDTH_MIN);
var StyledUnorderedList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "StyledUnorderedList",
  componentId: "sc-158x7z5-1"
})(["list-style-type:none;padding:0;margin:0;position:relative;@media (min-width:", "){overflow:hidden;}"], GEL_GROUP_3_SCREEN_WIDTH_MIN);
var ListItemBorder = /*#__PURE__*/css(["content:'';position:absolute;left:0;right:0;bottom:0;border-bottom:", " solid ", ";"], GEL_SPACING_HLF, C_WHITE);
var StyledLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledLink",
  componentId: "sc-158x7z5-2"
})(["", ";", " color:", ";cursor:pointer;text-decoration:none;display:inline-block;padding:", ";@media (max-width:", "){padding:", " ", ";}&:hover::after{", " ", "}&:focus::after{", " top:0;border:", " solid ", ";}"], function (_ref) {
  var script = _ref.script;
  return script && getPica(script);
}, function (_ref2) {
  var service = _ref2.service;
  return getSansRegular(service);
}, C_GHOST, SPACING_AROUND_NAV_ITEMS, GEL_GROUP_2_SCREEN_WIDTH_MAX, SPACING_AROUND_NAV_ITEMS, GEL_SPACING, ListItemBorder, function (_ref3) {
  var currentLink = _ref3.currentLink;
  return currentLink && css(["border-bottom:", " solid ", ";"], CURRENT_ITEM_HOVER_BORDER, C_WHITE);
}, ListItemBorder, GEL_SPACING_HLF, C_WHITE);
var StyledListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledListItem",
  componentId: "sc-158x7z5-3"
})(["display:inline-block;position:relative;z-index:2;@media (max-width:", "){&:last-child{", "}}@media (min-width:", "){&::after{content:'';position:absolute;bottom:0;width:", ";border-bottom:0.0625rem solid ", ";z-index:-1;}}"], GEL_GROUP_2_SCREEN_WIDTH_MAX, function (_ref4) {
  var dir = _ref4.dir;
  return css(["margin-", ":", ";"], dir === 'ltr' ? 'right' : 'left', GEL_SPACING_SEXT);
}, GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_5_SCREEN_WIDTH_MIN, BORDER_COLOR);
var StyledSpan = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledSpan",
  componentId: "sc-158x7z5-4"
})(["&::after{", "}"], ListItemBorder);

var CurrentLink = function CurrentLink(_ref5) {
  var link = _ref5.children,
      script = _ref5.script,
      currentPageText = _ref5.currentPageText;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledSpan // eslint-disable-next-line jsx-a11y/aria-role
  , {
    role: "text",
    script: script
  }, /*#__PURE__*/React.createElement(VisuallyHiddenText, null, currentPageText, ", "), link));
};

CurrentLink.propTypes = {
  children: string.isRequired,
  script: shape(scriptPropType).isRequired,
  currentPageText: string
};
CurrentLink.defaultProps = {
  currentPageText: null
};
export var NavigationUl = function NavigationUl(_ref6) {
  var children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["children"]);

  return /*#__PURE__*/React.createElement(StyledUnorderedList, _extends({
    role: "list"
  }, props), children);
};
NavigationUl.propTypes = {
  children: node.isRequired
};
export var NavigationLi = function NavigationLi(_ref7) {
  var link = _ref7.children,
      url = _ref7.url,
      script = _ref7.script,
      currentPageText = _ref7.currentPageText,
      active = _ref7.active,
      service = _ref7.service,
      dir = _ref7.dir,
      props = _objectWithoutProperties(_ref7, ["children", "url", "script", "currentPageText", "active", "service", "dir"]);

  return /*#__PURE__*/React.createElement(StyledListItem, {
    dir: dir,
    role: "listitem"
  }, active && currentPageText ? /*#__PURE__*/React.createElement(StyledLink, _extends({
    href: url,
    script: script,
    service: service,
    currentLink: true
  }, props), /*#__PURE__*/React.createElement(CurrentLink, {
    script: script,
    currentPageText: currentPageText
  }, link)) : /*#__PURE__*/React.createElement(StyledLink, _extends({
    href: url,
    script: script,
    service: service
  }, props), link));
};
NavigationLi.propTypes = {
  children: node.isRequired,
  url: string.isRequired,
  script: shape(scriptPropType).isRequired,
  active: bool,
  currentPageText: string,
  service: string.isRequired,
  dir: oneOf(['ltr', 'rtl'])
};
NavigationLi.defaultProps = {
  active: false,
  currentPageText: null,
  dir: 'ltr'
}; // ampOpenClass is the class added to the Navigation, and is toggled on tap.
// It indicates whether the menu is open or not. This overrides the background
// color of the Navigation

var StyledNav = /*#__PURE__*/styled.nav.withConfig({
  displayName: "StyledNav",
  componentId: "sc-158x7z5-5"
})(["position:relative;", " ", " border-top:0.0625rem solid ", ";", "{", "}"], function (_ref8) {
  var isOpen = _ref8.isOpen;
  return "background-color: ".concat(isOpen ? C_EBON : C_POSTBOX, ";");
}, function (_ref9) {
  var ampOpenClass = _ref9.ampOpenClass;
  return ampOpenClass && css(["&.", "{@media (max-width:", "){background-color:", ";}}"], ampOpenClass, GEL_GROUP_2_SCREEN_WIDTH_MAX, C_EBON);
}, C_WHITE, StyledListItem, function (_ref10) {
  var dir = _ref10.dir;
  return css(["&::after{", ":0;}"], dir === 'ltr' ? 'left' : 'right');
});

var Navigation = function Navigation(_ref11) {
  var children = _ref11.children,
      dir = _ref11.dir,
      isOpen = _ref11.isOpen,
      ampOpenClass = _ref11.ampOpenClass,
      props = _objectWithoutProperties(_ref11, ["children", "dir", "isOpen", "ampOpenClass"]);

  return /*#__PURE__*/React.createElement(StyledNav, _extends({
    role: "navigation",
    dir: dir,
    isOpen: isOpen,
    ampOpenClass: ampOpenClass
  }, props), /*#__PURE__*/React.createElement(NavWrapper, null, children));
};

Navigation.propTypes = {
  children: node.isRequired,
  dir: oneOf(['ltr', 'rtl']),
  isOpen: bool,
  ampOpenClass: string
};
Navigation.defaultProps = {
  dir: 'ltr',
  isOpen: false,
  ampOpenClass: null
};
export default Navigation;